export default function Tabs({ activeTab, setActiveTab }) {
  const tabs = ['General', 'Teams', 'Notifications'];

  return (
    <div className="flex">
      {tabs.map(tab => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`px-6 py-3 text-base font-medium ${
            activeTab === tab ? 'border-b-2 border-[#08F]' : 'text-gray-500'
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
